























import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrderDetails } from '@/api/paypal';
import { BASEURL } from '@/api/utils';

@Component
export default class BasicCheckedOut extends Vue {
  @Prop(Boolean) public readonly value!: boolean;
  @Prop(Object) public readonly details!: OrderDetails;

  private readonly url = BASEURL;

  public get show(): boolean {
    return this.value;
  }

  public set show(val: boolean) {
    this.$emit('input', val);
  }
}
